import React from "react";
import {
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { get } from "lodash";
import moment from "moment";
import { UserScheduleResponse } from "@beable/roster-backend-client-v1";

interface UserLessonScheduleDataProps {
  userSchedule?: UserScheduleResponse;
}
export default function UserLessonScheduleData({
  userSchedule,
}: UserLessonScheduleDataProps) {

  const lessonScheduleRowData =
    userSchedule &&
    userSchedule.assignedLessons.map((assignedLesson, index) => {
      const course = userSchedule.assignedContentCourses.find(
        (course) => course.courseId === assignedLesson.courseId
      );
      const classes = assignedLesson.classIds.map((classId) => {
        const userClass = userSchedule.userClasses.find(
          (userClass) => userClass.classId === classId
        );
        return get(userClass, "className", "");
      });

      return {
        id: `${assignedLesson.lessonId}_${index}`,
        courseName: get(course, "courseName", ""),
        lessonName: assignedLesson.lessonName,
        sort: assignedLesson.sort,
        startDate: assignedLesson.startDt,
        endDate: assignedLesson.endDt,
        classes: classes.join(", "),
      };
    });

  const sortedLessonScheduleRowData = lessonScheduleRowData
    ? [...lessonScheduleRowData].sort((a, b) => {
        const courseCompare = a.courseName.localeCompare(b.courseName);
        if (courseCompare !== 0) return courseCompare;

        const startCompare =
          moment(a.startDate).valueOf() - moment(b.startDate).valueOf();
        if (startCompare !== 0) return startCompare;

        return (a.sort ?? 0) - (b.sort ?? 0);
      })
    : undefined;
  
  const lessonScheduleColumnData = [
    { field: "id", headerName: "ID" },
    { field: "courseName", headerName: "Course", width: 200 },
    { field: "lessonName", headerName: "Lesson", width: 200 },
    { field: "sort", headerName: "Sort", width: 200 },
    {
      field: "startDate",
      headerName: "Start Date",
      width: 200,
      valueGetter: (_value: unknown, row: { startDate: Date | string }) =>
        moment(row.startDate as string).format("YYYY-MM-DD"),
    },
    {
      field: "endDate",
      headerName: "End Date",
      width: 200,
      valueGetter: (_value: unknown, row: { endDate: Date | string }) =>
        moment(row.endDate as string).format("YYYY-MM-DD"),
    },
    { field: "classes", headerName: "Classes", width: 200 },
  ];

  if (sortedLessonScheduleRowData?.length) {
    return (
      <DataGrid
        disableRowSelectionOnClick
        disableColumnSorting
        initialState={{
          columns: {
            columnVisibilityModel: {
              id: false,
              sort: false,
            },
          },
        }}
        rows={sortedLessonScheduleRowData}
        columns={lessonScheduleColumnData}
      />
    );
  } else {
    return <Typography>No schedule found</Typography>;
  }
}
